import React, { useState, useEffect, useCallback } from 'react';
import axios from '../../api/api';
import { toast } from 'sonner';
import * as XLSX from 'xlsx';
import { useNavigate } from 'react-router-dom'

const BuyAirtimeExcel = () => {

  const [selectedFile, setSelectedFile] = useState('');
  const [client_id, setClient_id] = useState('');
  const [listaccounts, setListaccounts] = useState([])
  const [isloading, setIsLoading] = useState(false);
  const [fileContent, setFileContent] = useState(null);
  const navigate = useNavigate()

  // Fetch user accounts
  const getAccounts = useCallback(async () => {
    try {
      const response = await axios.get('/service_clients/?service_ref_id=2');
      setListaccounts(response.data.items)
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    getAccounts()
  }, [getAccounts]);


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
    previewFile(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    setSelectedFile(file);
    previewFile(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const previewFile = (file) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      const binaryStr = event.target.result;
      const workbook = XLSX.read(binaryStr, { type: 'binary' });

      // first sheet is the one to preview
      const sheet = workbook.Sheets[workbook.SheetNames[0]];

      // Convert the sheet to JSON for easy display
      const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      setFileContent(data);
    };

    reader.readAsBinaryString(file);
  };

  // Reset form
  const handleReset = () => {
    window.location.reload()
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append('batch_file', selectedFile);
      formData.append('client_id', client_id);
      const response = await axios.post('/batch_request/upload-excel', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      toast.success(response.data.message);
      setSelectedFile('')
      setFileContent('')
      navigate('/app/airtime')
    } catch (error) {
      if (!error?.response) {
        toast.error('No Server Response');
      } else if (error.response?.status) {
        toast.error(error.response.data.detail);
      } else {
        toast.error('Failed to upload file!!');
      }
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <h4><b>Upload Airtime request</b></h4>
      <section className='p-4 bg-white rounded-lg mt-2'>
        <form onSubmit={handleSubmit}>
          {fileContent ? (
            <div className="py-4">
              <h4>File Preview:</h4>
              <table className="table-auto w-full border-collapse border">
                <thead>
                  <tr>
                    {fileContent[0].map((header, index) => (
                      <th key={index} className="border px-4 py-2">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {fileContent.slice(1).map((row, index) => (
                    <tr key={index}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className="border px-4 py-2">{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className='mt-2 w-full'>
                <label htmlFor='clientid'><span>Account</span>
                  <select 
                    name="service" id="service"
                    className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                    value={client_id}
                    required
                    onChange={(e) => setClient_id(e.target.value)}
                  >
                    <option value="">Select..</option>
                    {listaccounts.map((account) => (
                      <option key={account.id} value={account.client_id}>{account.client_id} - {account.units?.toLocaleString()} units</option>
                    ))}
                  </select>
                </label>
              </div>
              <div className='my-2 flex gap-2'>
                <button type="button" onClick={handleReset} className='bg-[#e6224d] text-white px-5 py-2 rounded-lg hover:bg-[#165277]'>Reset</button>
                <button disabled={isloading} className='bg-[#134463] text-white px-5 py-2 rounded-lg hover:bg-[#165277]'>{isloading ? 'Submitting...' : 'Submit request'}</button>
              </div>
            </div>
          ) : (
            <section>
              <div className='p-2'>
                <input
                  type='file'
                  id='file'
                  name='file'
                  accept='.xlsx'
                  className='hidden'
                  onChange={handleFileChange}
                />
                <label
                  htmlFor='file'
                  onDrop={handleDrop}
                  onDragOver={handleDragOver}
                  className='p-10 cursor-pointer inline-block text-center border-2 border-dashed border-[#134463] w-full'
                >
                  {selectedFile
                    ? (
                      <div>
                        <p>Selected File: {selectedFile.name}</p>
                      </div>
                      )
                    : (
                      <p>Drag & Drop or Click to Select File</p>
                      )}
                </label>
              </div>

              <div className="flex justify-end">
                <a href="https://drive.google.com/uc?export=download&id=1gpp1DfURA8lQRJFuHeYyV41DKkIeILo7" className='border border-[#134463] px-5 py-2 rounded-lg hover:bg-[#134463] hover:text-white'>Download Sample</a>
              </div>
            </section>
          )}
        </form>
      </section>
    </div>
  );
};

export default BuyAirtimeExcel;
